import * as DisplayTypes from 'customer-data-filters/filterQueryFormat/DisplayTypes';
import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
// @ts-expect-error Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
const EVENTS = {
  SOCIAL_INTERACTION_QA: '4-1151228',
  SOCIAL_INTERACTION: '4-1761800'
};
const fieldDefinitionsForUnifiedEvents = {
  [EVENTS.SOCIAL_INTERACTION]: {
    hs_channel_key: {
      type: PropertyTypes.ENUMERATION,
      fieldType: DisplayTypes.EnumerationDisplayType,
      referencedObjectType: ReferenceObjectTypes.SOCIAL_CHANNEL
    }
  },
  [EVENTS.SOCIAL_INTERACTION_QA]: {
    hs_channel_key: {
      type: PropertyTypes.ENUMERATION,
      fieldType: DisplayTypes.EnumerationDisplayType,
      referencedObjectType: ReferenceObjectTypes.SOCIAL_CHANNEL
    }
  }
};
export const getPropertyDefinitionOverrideForUnifiedEventProperty = (eventId, propertyName) => {
  const event = fieldDefinitionsForUnifiedEvents[eventId];
  if (event) {
    const override = event[propertyName];
    return override || undefined;
  }
  return undefined;
};